const cards = [
  {
    tag: "Healthcare",
    title: "Healthcare",
    body:
      "Clinical AI and EHR-embedded assistants are moving patient data through vendor models at a scale most BAA frameworks were never designed to govern. The average healthcare breach cost $10.9 million in 2024 and organizations carrying this exposure have not yet measured it.",
    consequence: "Gap: AI-scale data flow outside reviewed application boundaries.",
  },
  {
    tag: "Manufacturing",
    title: "Manufacturing",
    body:
      "Predictive quality and operations AI runs on proprietary process data across trust boundaries built for human users, not autonomous systems. When that data flows through a model without a defined security boundary, the exposure shows up in vendor audits, lost contracts, and IP that has already left the building.",
    consequence: "Gap: production data inside AI systems without a defined trust boundary.",
  },
  {
    tag: "Financial Services",
    title: "Financial Services",
    body:
      "Credit decisioning, fraud detection, and customer-facing AI carry the highest regulatory and litigation exposure of any industry. At $6.08 million average breach cost and with SEC and OCC oversight accelerating, the firms that validate their AI security posture now are the ones that pass the next examination.",
    consequence: "Gap: AI in regulated financial workflows without validated model risk controls.",
  },
];

export default function ArqProblem() {
  return (
    <section className="bg-arq-surface1 py-20 md:py-[120px] px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center max-w-[820px] mx-auto mb-16">
          <div className="arq-label mb-6">The Current State</div>
          <h2 className="font-display font-semibold text-arq-text mb-8" style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}>
            Most Teams Are Shipping AI Faster Than They Can Secure It.
          </h2>
          <div className="space-y-5 text-arq-muted text-[17px] leading-[1.75] max-w-[760px] mx-auto text-left">
            <p>
              AI risk rarely starts with the model alone. It starts when AI connects to product
              data, customer records, permissions, documents, workflows, logs, and third-party
              systems.
            </p>
            <p>
              For teams launching chatbots, copilots, RAG search, AI agents, or workflow
              automation, the practical questions are:
            </p>
            <ul className="space-y-2 text-[16px] text-arq-text/90">
              {[
                "Can one customer access another customer's data?",
                "Can a prompt manipulate an internal workflow?",
                "Can RAG expose restricted documents?",
                "Are sensitive prompts and responses being logged?",
                "Can the team prove the feature is safe enough for enterprise review?",
              ].map((q) => (
                <li key={q} className="flex items-start gap-3">
                  <span className="text-arq-blue mt-1">›</span>
                  <span>{q}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {cards.map((c) => (
            <div key={c.title} className="arq-card p-8">
              <span className="arq-tag-risk mb-5 inline-block">{c.tag}</span>
              <h3 className="font-display text-[20px] font-semibold text-arq-text mb-3 mt-2">
                {c.title}
              </h3>
              <p className="text-arq-muted text-[15px] leading-[1.7]">{c.body}</p>
              <p className="text-[12px] font-mono text-arq-tertiary mt-3 leading-[1.5]">{c.consequence}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
